import { memo } from 'react';
import useRecommendationsApi from '../../../api/recommendations';
import AnnonceItem from '../../AnnonceItem';
import './RecoCard.css';

function RecoCard({ annonce, source, onOpenModal, ...itemProps }) {
  const { trackEvents } = useRecommendationsApi();

  // Capture les clics (détails, favori, demande) sans modifier AnnonceItem
  const handleClickCapture = () =>
    trackEvents([
      {
        type: 'click',
        vehiculeAnnonceId: annonce.vehiculeAnnonceId,
        rank: annonce.aiRank,
        source,
      },
    ]);

  return (
    <div className="mv-reco-card">
      <div onClickCapture={handleClickCapture}>
        <div className="mv-reco-card-reason">
          <span className="mv-reco-card-rank">#{annonce.aiRank}</span>
          <i className="bi bi-stars" />
          <span>{annonce.aiReason}</span>
          {source === 'gemini' && <small>{annonce.aiScore}% de compatibilité</small>}
        </div>

        <AnnonceItem propsData={annonce} {...itemProps} />
      </div>
    </div>
  );
}

export default memo(RecoCard);
